import { useState } from 'react';
import BasicModal from '../BasicModal';
import CustomizedButton from '../WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button';
import CustomTextField from '../WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/TextfieldBox';
import { WhatsAppIcon } from '@/assets/svgExports/WhatsAppIcon3';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { pushWhatsAppLead, setWhatsAppLeadModalState } from 'src/redux/actions';
import { getWhatAppRedirectionUrl } from 'src/utils/getWhatsAppRedirectionUrl';
import { Close } from '@mui/icons-material';
import { isValidPhoneNumber } from 'src/utils/regex';
import { toastNotifyError } from '../Common/Toast';

export function WhatsAppLeadGenerationModal() {
  const dispatch = useDispatch();

  const { showModal, storeUrl, storeId, userPhone } = useSelector((state: RootState) => ({
    showModal: state.commonReducer?.whatsAppLeadModalState?.show,
    storeUrl: state.storeReducer.store?.store_info?.store_url,
    storeId: state.storeReducer.store?.store_id,
    userPhone: state.userReducer?.data?.phone,
  }));

  const [contact, setContact] = useState(userPhone ?? '');
  const [message, setMessage] = useState(
    "Hi, I'm at your online store and need some help"
  );

  function handleContact(value) {
    if (isNaN(Number(value)) || value?.length > 10) {
      return;
    }
    setContact(value?.trim());
  }

  function closeModal() {
    dispatch(setWhatsAppLeadModalState({ show: false }));
  }

  function handleLeadSubmission() {
    if (!isValidPhoneNumber(contact)) {
      toastNotifyError('Please enter a valid phone number!');
      return;
    }

    let finalMessage = message?.trim();

    if (!finalMessage?.trim()) {
      toastNotifyError('Please enter a message!');
      return;
    }

    if (finalMessage?.length < 10) {
      toastNotifyError('Message is too short!');
      return;
    }

    if (finalMessage?.length > 100) {
      finalMessage = finalMessage?.slice(0, 100);
    }

    const leadPayload = {
      store_id: storeId,
      phone_number: contact,
      enquiry: message,
    };

    dispatch(pushWhatsAppLead(leadPayload));
    const completeMessage = encodeURIComponent(`${message}. ${storeUrl}`);
    window.open(getWhatAppRedirectionUrl(completeMessage), '_blank');
    closeModal();
  }

  return (
    <BasicModal
      show={showModal}
      onClose={closeModal}
      customClasses="!tw-rounded-[16px_16px_0px_0px]  md:!tw-rounded-[16px] !tw-w-full  md:!tw-w-[400px] !tw-min-w-fit"
      headingClasses="!tw-border-none !tw-p-0"
      customCloseIcon={
        <div
          onClick={closeModal}
          className="tw-absolute tw-right-[16px] tw-top-[12px] tw-flex tw-h-[32px] tw-w-[32px] tw-items-center tw-justify-center tw-rounded-full tw-bg-[#F7F7F7]"
        >
          <Close fontSize="small" />
        </div>
      }
    >
      <div className="tw-flex !tw-min-h-[480px] tw-flex-1 tw-flex-col tw-justify-between tw-gap-[32px] tw-px-[24px] tw-py-[28px] md:!tw-min-h-fit ">
        <div className="tw-flex tw-flex-col tw-gap-[24px]">
          <div className="tw-flex tw-flex-col tw-gap-[16px]">
            <WhatsAppIcon />
            <p className="tw-m-0 tw-text-[20px]/[100%] tw-font-semibold">
              Chat with us on WhatsApp
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-[20px]">
            <CustomTextField
              placeholder="Enter your number"
              value={contact}
              handleChange={handleContact}
              parentClass=""
              borderRadiusClass="!tw-rounded-[6px]"
              showErrorBox={false}
              rows={1}
            />
            <CustomTextField
              placeholder="Enter your message or enquiry"
              value={message}
              handleChange={(value) => setMessage(value)}
              parentClass=""
              borderRadiusClass="!tw-rounded-[6px]"
              showErrorBox={false}
              rows={4}
            />
          </div>
        </div>
        <CustomizedButton
          variant="primary"
          className="!tw-rounded-lg !tw-py-[12px] !tw-text-sm !tw-font-semibold"
          onClick={handleLeadSubmission}
        >
          Start a chat
        </CustomizedButton>
      </div>
    </BasicModal>
  );
}
